import { useEffect } from 'react';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogImage?: string;
  canonicalPath?: string; // e.g. '/filament/compare'
}

const BASE_URL = 'https://www.sekisonagnote.jp';
const DEFAULT_TITLE = 'せきそうNAGノート';
const DEFAULT_DESCRIPTION = '個人運営のFDM式3Dプリンター研究ノート。フィラメント設定データ、トラブルシューティング、実測データを記録・公開しています。';
const DEFAULT_IMAGE = `${BASE_URL}/assets/nag-logo-512.png`;

export const useSEO = ({
  title,
  description,
  keywords,
  ogImage,
  canonicalPath
}: SEOProps) => {
  useEffect(() => {
    // タイトルは常に「ページ名 - せきそうNAGノート」形式に統一
    const fullTitle = title ? `${title} - せきそうNAGノート` : DEFAULT_TITLE;
    const fullDescription = description || DEFAULT_DESCRIPTION;
    const canonicalUrl = canonicalPath
      ? `${BASE_URL}${canonicalPath.endsWith('/') ? canonicalPath : canonicalPath + '/'}`
      : `${BASE_URL}${window.location.pathname.endsWith('/') ? window.location.pathname : window.location.pathname + '/'}`;
    const imageUrl = ogImage ? `${BASE_URL}${ogImage}` : DEFAULT_IMAGE;

    // Update title
    document.title = fullTitle;

    // Update or create meta tags
    const updateMetaTag = (property: string, content: string, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${property}"]`);
      
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, property);
        document.head.appendChild(element);
      }
      
      element.setAttribute('content', content);
    };

    // Basic meta tags
    updateMetaTag('description', fullDescription);
    if (keywords) {
      updateMetaTag('keywords', keywords);
    }

    // Open Graph tags
    updateMetaTag('og:title', fullTitle, true);
    updateMetaTag('og:description', fullDescription, true);
    updateMetaTag('og:url', canonicalUrl, true);
    updateMetaTag('og:image', imageUrl, true);
    updateMetaTag('og:type', 'website', true);

    // Twitter Card tags
    updateMetaTag('twitter:card', 'summary');
    updateMetaTag('twitter:title', fullTitle);
    updateMetaTag('twitter:description', fullDescription);
    updateMetaTag('twitter:image', imageUrl);

  }, [title, description, keywords, ogImage, canonicalPath]);
};
